var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"how__it_works"},_vm._l((_vm.points),function(point,index){return _c('tile',{key:index,attrs:{"point":point,"title":_vm.showTitle}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }